import { useEffect, useState } from 'react';
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';
import swal from "sweetalert";

import { getContactdetal, SaveConteactdetail } from '../../Services/Service';



const Contact = () => {
  const [loading, setLoading] = useState(false);

  const [contactformData, setcontactFormData] = useState({
    ContactID: 0,
    HotelPhone: '',
    HotelMobile: '',
    HotelEmail: '',
    CustomerCareNumber: '',
    PhoneList: '',
    WebsiteList: '',
    EmailList: '',
  });

  useEffect(() => {
    const getContectdetails = async () => {
      setLoading(true);
      try {
        const result = await getContactdetal();
        console.log("contact", result)
        if (result && result.length > 0) {
          setcontactFormData(result[0]);
        }
      }
      catch (error) {
        console.lof("error getting contact details", error);
      } finally {
        setLoading(false);
      }
    }
    getContectdetails();
  }, []);

  // Submit Handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const user = JSON.parse(localStorage.getItem("userData"));
      const property = JSON.parse(localStorage.getItem("selectedProperty"));

      const dataToSend = {
        ...contactformData,
        ContactID: contactformData.ContactID || 0,
        PropertyID: property?.id || 0,
        CreatedBy: user?.id || 0,
        CreatedDateTime: new Date().toISOString(),
        ModifyBy: 0,
        ModifyDateTime: new Date().toISOString(),
        ConfirmationStatus: 0,
      };

      const res = await SaveConteactdetail(dataToSend);

      if (res) {
        swal("Contact Details Saved Successfully", {
          icon: "success",
          buttons: {
            confirm: {
              text: "OK",
              className: "btn btn-success",
            },
          },
        });
      } else {
        alert(" Failed to save contact details");
      }
    } catch (error) {
      console.error("Error saving contact details:", error);
      alert("An error occurred while saving contact details.");
    } finally {
      setLoading(false);
    }
  };



  return (
    <>

      {loading && (
        <div className="fullscreen-loader">
          <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
        </div>
      )}

      <div className="wrapper">
        <SideBar />
        <div className="main-panel">
          <Hearder />
          <div className="container">
            <div className="page-inner">

              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">Contact Details</div>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className="row">

                          <div className="col-md-4">
                            <div className="input-block ">
                              <label className="col-form-label">Hotel Phone</label>
                              <input type="tel" className="form-control" placeholder="Enter Hotel Phone" min={0} value={contactformData.HotelPhone} onChange={(e) =>
                                setcontactFormData({ ...contactformData, HotelPhone: e.target.value })
                              } required />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="input-block ">
                              <label className="col-form-label">Hotel Mobile</label>
                              <input type="tel" className="form-control" placeholder="Enter Hotel Mobile Number" min={0} value={contactformData.HotelMobile} onChange={(e) => setcontactFormData({ ...contactformData, HotelMobile: e.target.value })} />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="input-block ">
                              <label className="col-form-label">Hotel Email</label>
                              <input type="email" className="form-control" placeholder="Enter Hotel Email" value={contactformData.HotelEmail} onChange={(e) => setcontactFormData({ ...contactformData, HotelEmail: e.target.value })} />
                            </div>
                          </div>


                          <div className="col-md-6">
                            <div className="input-block ">
                              <label className="col-form-label">Customer Care Number</label>
                              <textarea className="form-control" rows="2" placeholder="Enter Customer Care Number" value={contactformData.CustomerCareNumber} onChange={(e) => setcontactFormData({ ...contactformData, CustomerCareNumber: e.target.value })}  ></textarea>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input-block ">
                              <label className="col-form-label">Phone List</label>
                              <textarea className="form-control" rows="2" placeholder="Enter Phone List" value={contactformData.PhoneList} onChange={(e) => setcontactFormData({ ...contactformData, PhoneList: e.target.value })}  ></textarea>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input-block ">
                              <label className="col-form-label">Website List</label>
                              <textarea className="form-control" rows="2" placeholder="Enter Website List" value={contactformData.WebsiteList} onChange={(e) => setcontactFormData({ ...contactformData, WebsiteList: e.target.value })}  ></textarea>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Email List</label>
                              <textarea className="form-control" rows="2" placeholder="Enter Email List" value={contactformData.EmailList} onChange={(e) => setcontactFormData({ ...contactformData, EmailList: e.target.value })}  ></textarea>
                            </div>
                          </div>
                        </div>
                        <div className="card-action text-end">
                          <button type="submit" className="btn btn-primary">Submit</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </>
  )
}

export default Contact;
